var React = require('react');

function Searchsss (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1_485)","key":0},[React.createElement("path",{"d":"M12.193 12.193L18.3334 18.3333","stroke":"#888888","strokeWidth":"1.66667","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M7.80702 13.9473C11.1982 13.9473 13.9474 11.1982 13.9474 7.80698C13.9474 4.41577 11.1982 1.66663 7.80702 1.66663C4.41581 1.66663 1.66666 4.41577 1.66666 7.80698C1.66666 11.1982 4.41581 13.9473 7.80702 13.9473Z","stroke":"#888888","strokeWidth":"1.66667","strokeLinejoin":"round","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1_485"},React.createElement("rect",{"width":"20","height":"20","fill":"white"})))]);
}

Searchsss.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Searchsss;

Searchsss.default = Searchsss;
